// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-header[data-v-3d3e8500] {\n    font-weight: 300;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    font-size: 16px;\n    margin: 20px 0;\n}\n.v-list-item__subtitle[data-v-3d3e8500]::first-letter {\n    text-transform: capitalize;\n}\n.break-lines[data-v-3d3e8500] {\n    white-space: break-spaces;\n}\n", ""]);
// Exports
module.exports = exports;
